import { Button } from 'components';
import { RepresentativeForm } from 'components/Forms/RepresentativeForm';
import { RepresentativeDocumentsForm } from 'components/Forms/RepresentativeForm/RepresentativeDocumentsForm';
import { BreadcrumbsHeader } from 'components/molecules/BreadcrumbsHeader';
import { PaperCardTemplate } from 'components/templates/PaperCardTemplate';
import { useRepresentative } from 'hooks/useRepresentative';
import { FC, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useHistory, useParams } from 'react-router-dom';
import { IRepresentant } from 'types/Representant';

import { Grid } from '@mui/material';

export const RepresentativeCreateUpdate: FC = () => {
  const { goBack } = useHistory();
  const { saveRepresentative, loading, getRepresentative } =
    useRepresentative();
  const { handleSubmit } = useFormContext<IRepresentant>();

  const { representativeId } = useParams<{ representativeId: string }>();

  useEffect(() => {
    getRepresentative(representativeId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [representativeId]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} mb={1}>
        <BreadcrumbsHeader
          items={[
            { title: 'Representante' },
            { title: 'Cadastro de Representante' },
          ]}
        />
      </Grid>

      <Grid item xs={12}>
        <PaperCardTemplate loading={loading}>
          <RepresentativeForm />
        </PaperCardTemplate>
      </Grid>

      <Grid item container mt={2} spacing={2}>
        <Grid item sm={12} md={9}>
          <RepresentativeDocumentsForm />
        </Grid>

        <Grid
          item
          container
          sm={12}
          md={3}
          spacing={2}
          justifyContent="flex-end"
        >
          <Grid item>
            <Button onClick={goBack}>Voltar</Button>
          </Grid>

          <Grid item>
            <Button
              disabled={loading}
              onClick={handleSubmit(saveRepresentative)}
              loading={loading}
            >
              {representativeId ? 'ATUALIZAR' : 'CADASTRAR'}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
